import { render, staticRenderFns } from "./notificationStack.vue?vue&type=template&id=68a0a981&scoped=true&"
import script from "./notificationStack.vue?vue&type=script&lang=js&"
export * from "./notificationStack.vue?vue&type=script&lang=js&"
import style0 from "./notificationStack.vue?vue&type=style&index=0&id=68a0a981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0a981",
  null
  
)

export default component.exports